// Vite exposes REACT_APP_* vars via envPrefix in vite.config.js
const getEnvVar = (key, defaultValue = "") => {
  const value = import.meta.env[key];
  return value !== undefined && value !== "" ? value : defaultValue;
};

const isProd = import.meta.env.PROD;

const SERVER_NAME = getEnvVar(
  "REACT_APP_SERVER_NAME",
  isProd ? "https://eduok.in/" : "https://beta.eduok.in/"
);
const TARGET_DIR_CRM = getEnvVar(
  "REACT_APP_TARGET_DIR_CRM",
  isProd ? "PiZeroApi_Live/ver1/CrmApi/" : "PiZeroApi_Beta/ver1/CrmApi/"
);

const environment = {
  IS_DEVELOPMENT: import.meta.env.DEV,
  IS_PRODUCTION: isProd,

  SERVER_NAME,
  TARGET_DIR_CRM,
  PHP_API_URL: getEnvVar("REACT_APP_PHP_API_URL", SERVER_NAME + TARGET_DIR_CRM),
  API_URL: getEnvVar("REACT_APP_API_URL", "http://localhost:3001/api"),
  API_TIMEOUT: parseInt(getEnvVar("REACT_APP_API_TIMEOUT", "10000"), 10),
  SYSTEM_CODE: getEnvVar("REACT_APP_SYSTEM_CODE", "12"),

  DEBUG_MODE:
    getEnvVar("REACT_APP_DEBUG_MODE", isProd ? "false" : "true") === "true",
  ENABLE_NOTIFICATIONS:
    getEnvVar("REACT_APP_ENABLE_NOTIFICATIONS", "true") === "true",

  /** School public-website CRM API (EduOKSchool/SchoolWebApi/CrmApi) */
  WEBSITE_API_URL: getEnvVar(
    "VITE_WEBSITE_API_URL",
    "https://school.codegenius.in/api/CrmApi"
  ).replace(/\/+$/, ""),

  /** Manage / school ERP web app (App Access CRM login) */
  MANAGE_APP_URL: getEnvVar(
    "REACT_APP_MANAGE_APP_URL",
    "https://www.manage.eduokerp.com"
  ).replace(/\/+$/, ""),
};

export default environment;
